export default __webpack_public_path__ + "static/media/logo-white.c82dde46.png";